export default class Extras {

	constructor() {
		this.instance = self;
	}

	static init() {
		self.attachSelectric();
	}

	attachSelectric() {
		$('.js-styled-select').selectric();
	}
}

const self = new Extras;